import React, { useState } from 'react';
import { change, reset, submit } from 'redux-form';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as $ from 'jquery';
import { SaveButton } from '../../../../../../itrust_common/components/others';
import LabOrderForm from './LabOrderForm';
import { orderLoad } from '../../../../../../redux/actions/order/orderActions';
import Alert from '../../../../../../itrust_common/components/Alert';
import {
  labOrderCreate,
  labOrderEditCancel,
  labOrderUpdate,
  sendToVisionWebCreate
} from '../../../../../../redux/actions/order/labOrderActions';
import VisionWebOrderForm from '../visionWebOrderForm/VisionWebOrderForm';

function LabOrderModal(props) {
  const {
    orderId,
    resourceType,
    resourceId,
    saving
  } = props;
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(1);
  // Separate form names for Fax and Vision Web
  const labOrderFormName = `labOrderForm-${resourceId}`;
  const visionWebFormName = `visionWebOrderForm-${resourceId}`;
  // Get values only from Vision Web form
  const visionWebFormValues =
    useSelector(
      state => state.form?.[visionWebFormName]?.values
    ) || {};

  const storeSettings =
    useSelector(
      state => state.storeSetting?.store_settings || []
    );
  const visionWebSetting = storeSettings.find(
    item =>
      item.category === 'vision_web' &&
      item.store_config?.status === 'active'
  );
  const shouldShowVisionWebTabs =
    visionWebSetting &&
    resourceType === 'Orders::Eyeglass';
  const handleLabOrderEditCancel = () => {
    dispatch(labOrderEditCancel());
    $(`#${labOrderFormName}-modal`).modal('hide');
  };
  const handleLabOrderSend = async ({ submit_to_abb } = {}) => {
    if (submit_to_abb) {
      await dispatch(
        change(
          labOrderFormName,
          'submit_to_abb',
          submit_to_abb
        )
      );
    } else {
      await dispatch(
        change(
          labOrderFormName,
          'send_fax',
          true
        )
      );
    }

    dispatch(submit(labOrderFormName));
  };
  const handleVisionWebSend = () => {
    const payload = {
      orders_order_id: orderId,
      submission_type: 'vision_web',
      resource_type: resourceType,
      resource_id: resourceId,
      send_to_visionweb: true,
      integration_details: {
        bill_account: visionWebFormValues.bill_account,
        ship_account: visionWebFormValues.ship_account,
        job_type: visionWebFormValues.job_type,
        message_to_lab: visionWebFormValues.message_to_lab,
        location_id: visionWebFormValues.location_id
          ? Number(visionWebFormValues.location_id)
          : undefined
      }
    };

    dispatch(sendToVisionWebCreate(payload))
      .then(() => {
        handleLabOrderFormClose();
      })
      .catch(() => {
      });
  };

  const handleLabOrderSubmit = data => {
    const payload = {
      ...data,
      resource_type: resourceType,
      resource_id: resourceId,
      orders_order_id: orderId,
      submission_type: 'fax'
    };

    if (payload.send_fax && !payload.contact_id) {

      Alert.warning(
        'To send Lab Order Secure Fax need to be selected.'
      );

      dispatch(
        change(
          labOrderFormName,
          'send_fax',
          false
        )
      );

      return;
    }
    if (payload.id !== undefined) {
      dispatch(labOrderUpdate(payload))
        .then(response =>
          handleAfterLabOrderSubmit(response, payload)
        )
        .catch(() => {

          dispatch(
            change(
              labOrderFormName,
              'send_fax',
              false
            )
          );
        });
    } else {
      dispatch(labOrderCreate(payload))
        .then(response =>
          handleAfterLabOrderSubmit(response, payload)
        )
        .catch(() => {
          dispatch(
            change(
              labOrderFormName,
              'send_fax',
              false
            )
          );
        });
    }
  };


  const handleAfterLabOrderSubmit = (response, data) => {
    dispatch(
      orderLoad(
        orderId,
        {
          include: '*'
        }
      )
    );

    const url =
      response.value.data.lab_order.pdf_attributes.file.url;
    window.open(url, '_blank');
    if (
      data.send_fax ||
      data.send_to_visionweb
    ) {
      handleLabOrderFormClose();
    }
  };
  const handleLabOrderFormClose = () => {
    $(`#${labOrderFormName}-modal`).modal('hide');
    dispatch(reset(labOrderFormName));
    dispatch(reset(visionWebFormName));
    dispatch(labOrderEditCancel());
  };
  return (
    <div className="inner-modal">
      <div
        className="modal fade popper overflow-auto"
        id={`${labOrderFormName}-modal`}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div
          className="modal-dialog modal-md"
          role="document"
        >
          <div
            className="modal-content border-0 rounded shadow-lg"
          >
            {shouldShowVisionWebTabs && (
              <h5 className="text-dark pl-5 pt-3 mt-4">
                Lab Order
              </h5>
            )}
            <div
              className="modal-header align-items-center border-0"
            >
              {shouldShowVisionWebTabs ? (
                <div
                  className="text-nowrap overflow-auto mx-0 border border-radius-6 px-1 py-2 mt-4 bg-white"
                >
                  <ul
                    className="nav nav-pills p-3 border-0"
                    role="tablist"
                  >
                    <li
                      className="nav-item nav-items"
                      onClick={() => setActiveTab(1)}
                    >
                      <a
                        className={`p-3 mr-3 tab-link ${
                          activeTab === 1
                            ? 'active full-bg-green'
                            : ''
                        }`}
                        href="#lab-order"
                        data-toggle="tab"
                        role="tab"
                      >
                        Fax
                      </a>
                    </li>
                    <li
                      className="nav-item nav-items"
                      onClick={() => setActiveTab(2)}
                    >
                      <a
                        className={`p-3 mr-3 tab-link ${
                          activeTab === 2
                            ? 'active full-bg-green'
                            : ''
                        }`}
                        href="#vision-web"
                        data-toggle="tab"
                        role="tab"
                      >
                        Vision Web
                      </a>
                    </li>
                  </ul>
                </div>
              ) : (

                <h5 className="text-dark">
                  Lab Order
                </h5>

              )}
              <div className="d-flex flex-row">

                <button
                  type="button"
                  className="btn btn-outline-primary mr-2"
                  onClick={handleLabOrderEditCancel}
                >
                  Cancel
                </button>
                {activeTab === 1 && (
                  <>

                    <button
                      type="button"
                      className="btn btn-primary mx-5"
                      onClick={() => handleLabOrderSend()}
                    >
                      Send
                    </button>
                    <SaveButton
                      buttonClasses=""
                      label="Save and Create"
                      saving={saving}
                      handleOnClick={() =>
                        dispatch(submit(labOrderFormName))
                      }
                    />
                  </>
                )}
                {activeTab === 2 && (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary mx-5"
                      onClick={handleVisionWebSend}
                      disabled={saving}
                    >
                      {saving
                        ? 'Sending...'
                        : 'Send to Vision Web'}
                    </button>

                  </>
                )}
              </div>
            </div>
            <div className="tab-content">
              <div
                id="lab-order"
                className={`tab-pane fade ${
                  !shouldShowVisionWebTabs ||
                  activeTab === 1
                    ? 'show active'
                    : ''
                }`}
              >
                <LabOrderForm
                  resourceId={resourceId}
                  resourceType={resourceType}
                  onSubmit={handleLabOrderSubmit}
                  form={labOrderFormName}
                />
              </div>
              {shouldShowVisionWebTabs && (
                <div
                  id="vision-web"
                  className={`tab-pane fade ${
                    activeTab === 2
                      ? 'show active'
                      : ''
                  }`}
                >
                  <VisionWebOrderForm
                    form={visionWebFormName}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => {
  const {
    labOrder,
    order: { order }
  } = state;
  return {
    saving: labOrder.saving,
    orderId: order.id
  };
};

export default connect(mapStateToProps)(LabOrderModal);
